module.exports = __webpack_public_path__ + "img/CheckCircle.f7bd1a44.svg";